import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { StatefulComponent } from '../../components/stateful/stateful.component';
import { setContainerTypeAction, showLoadingMaskAction } from '../../ngrx/actions/global.actions';
import { AuthorizeService } from '../../services/authorize.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-registration-confirmation',
  templateUrl: './registration-confirmation.component.html',
  styleUrls: ['./registration-confirmation.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink]
})
export class RegistrationConfirmationComponent extends StatefulComponent implements OnInit {
  confirmationStatus: 'loading' | 'success' | 'error' = 'loading';
  message: string = '';
  email: string = '';
  token: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthorizeService
  ) {
    super();
  }

  ngOnInit() {
    this.dispatch(setContainerTypeAction({ containerType: 'normal' }));
    this.dispatch(showLoadingMaskAction({ showLoadingMask: true }));

    // Get email and token from query params
    this.route.queryParams.subscribe(params => {
      this.email = params['email'];
      this.token = params['token'];

      if (!this.email || !this.token) {
        this.confirmationStatus = 'error';
        this.message = 'Invalid confirmation link. Email and token are required.';
        this.dispatch(showLoadingMaskAction({ showLoadingMask: false }));
        return;
      }

      // Call the confirmation endpoint
      this.subs.push(
        this.authService.confirmRegistration(this.email, this.token).subscribe({
          next: (response) => {
            this.confirmationStatus = response.success ? 'success' : 'error';
            this.message = response.message;
            this.dispatch(showLoadingMaskAction({ showLoadingMask: false }));
          },
          error: (error) => {
            this.confirmationStatus = 'error';
            this.message = 'An error occurred while confirming your registration. Please try again later.';
            this.dispatch(showLoadingMaskAction({ showLoadingMask: false }));
          }
        })
      );
    });
  }

  navigateToLogin() {
    this.router.navigate(['/authentication/login']);
  }
}
